import {appStyle} from './map-styles.mjs';
// First show real vector geometry and sites; imagery/glyphs must not hold back that
// usable map. Restore exactly the original symbol layers after its first paint.
export function basemapStart(map,ready,{frame=requestAnimationFrame,restored=()=>{}}={}) {
  let pending=null,active=true,raster=false,keep=[];
  const deferred=l=>l.type==='symbol'||(raster&&l.type==='raster');
  const cancel=()=>{active=false;pending=null;map.off('render',rendered);};
  function rendered(){
    if(!pending||!ready())return;
    const layers=pending;pending=null;map.off('render',rendered);
    frame(()=>{
      if(!active)return;
      // Reverse insertion preserves both consecutive labels and their position
      // among road/land layers. Labels go above the site dots but below pins and hits.
      for(let i=layers.length-1;i>=0;i--)if(deferred(layers[i])){
        const before=layers.slice(i+1).find(l=>map.getLayer(l.id))?.id||'points';
        map.addLayer(layers[i],map.getLayer(before)?before:undefined);
      }
      for(const l of keep)if(map.getLayer(l.id))map.removeLayer(l.id);
      active=false;restored();
    });
  }
  map.on('render',rendered);
  return {cancel,transform:(_,style)=>{
    const next=appStyle(style);pending=next.layers;
    // A raster-only style has no useful vector map to show in its place.
    raster=next.layers.some(l=>l.type==='fill'&&next.sources[l.source]?.type==='vector');
    const shown=next.layers.filter(l=>!deferred(l));
    keep=placeholders(next,shown,next.layers.filter(deferred));
    return {...next,layers:[...shown,...keep]};
  }};
}
// MapLibre slices overzoomed vector tiles (beyond the source maxzoom) in the worker and keeps
// only the source layers some shown style layer uses; the slice is cached per tile URL, so a
// reload after the labels return would still lack them. An empty layer per symbol-only source
// layer (pois, places) keeps those features in the slice until the labels are back.
function placeholders(style,shown,deferredLayers) {
  const used=new Set(shown.map(l=>l.source+'/'+l['source-layer'])),out=[];
  for(const l of deferredLayers){
    const key=l.source+'/'+l['source-layer'];
    if(!l['source-layer']||style.sources[l.source]?.type!=='vector'||used.has(key))continue;
    used.add(key);
    out.push({id:'start-keep-'+out.length,type:'circle',source:l.source,'source-layer':l['source-layer'],
      filter:['==',['geometry-type'],'None'],paint:{'circle-radius':0}});
  }
  return out;
}
